import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { capturePageview } from '../utils/analytics';

// ----------------------------------------------------------------------

// Captures a $pageview on every client-side route change. In this SPA the
// PostHog snippet's automatic pageview only fires on the initial document
// load (capture_pageview is disabled in index.html to avoid double-counting),
// so internal navigation would otherwise be invisible.
export default function PostHogPageView() {
  const { pathname } = useLocation();

  useEffect(() => {
    capturePageview();
  }, [pathname]);

  return null;
}
